import api from "./api";

export const getAllDuplicatedSubscribers = (page) =>{
  return api.get(`admin/subscribers/duplicated`, {params: {page: page}});
};

export const getSubscribers = (page, params) => {
  return api.get("admin/subscribers", { params: { page: page, limit: 10, ...params} });
};

export const getSubscriberBySearch = (searchItem, search) => {
  return api.get(`admin/Subscriber?searchItem=${searchItem}&search=${search}`);
};

export const updateSubscriber = (subscriberId, update) => {
  return api.put(`admin/Subscriber/item/${subscriberId}`, { object: update });
};

export const getSubscriberData = (subscriberId) => {
    return api.get(`admin/subscriber/${subscriberId}`)
};

export const unsubscribeMembership = (uid) =>{
  return api.post(`admin/membership/${uid}/unsubscribe`)
};

export const unsubscribeSubscription = (uid) =>{
  return api.delete(`admin/subscription/${uid}/unsubscribe`)
};

